import { endOfYear, startOfYear } from 'date-fns'
import { useMemo } from 'react'

import * as S from '../DatePicker.styles'
import { ViewComponentProps } from '../DatePicker.types'
import { getYears } from '../DatePicker.utils'

export const YearView = ({ preset, onChange }: ViewComponentProps) => {
  const yearViewPreset = useMemo(() => getYears(), [])

  const handleSelectPreset = (year: number) => {
    const referenceDate = new Date(year, 0)
    onChange({
      value: { startDate: startOfYear(referenceDate), endDate: endOfYear(referenceDate) },
      metadata: { preset: String(year) },
    })
  }

  return (
    <S.ViewGrid $columns={1} $marginTop={0}>
      {yearViewPreset.map(yearViewPreset => (
        <S.ViewPresetButton
          key={`year-view-preset-${yearViewPreset}`}
          aria-selected={String(yearViewPreset) === preset}
          onClick={() => handleSelectPreset(yearViewPreset)}
        >
          {yearViewPreset}
        </S.ViewPresetButton>
      ))}
    </S.ViewGrid>
  )
}
